import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from "react-translate";
import { connect } from 'react-redux'
import {
    Link
} from 'react-router-dom'

import {
    Button,
    Container,
    Segment,
    Menu,
    Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Advertisement,
    Icon,
    Divider,
    Table,
    Input,
    Item,
    Form,
    TextArea
} from 'semantic-ui-react';
import './contact.css'

import NousContacter from '../../../assets/icons/NousContacter.png';
import ContactNews from '../../../assets/svg/ContactNews.svg';
import Contact1 from '../../../assets/svg/Contact1.svg';
import Contact2 from '../../../assets/svg/Contact2.svg';
import Contact3 from '../../../assets/svg/Contact3.svg';

import API from '../../../services/api';

var sectionStyle = {
    backgroundImage: "url(" + NousContacter + ")",
    // marginTop: '1em',
    // marginLeft: '3em',
    // marginRight: '3em',
    // borderRadius: '4px',
    // minHeight: '200px'
}


const mapStateToProps = state => ({
    app: state.app
});

class ConnectedContactUsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: null,
            message: null,
            name: null,
        };
        if(this.props.app && this.props.app.contactInfo) {
            this.state = {
                email: this.props.app.contactInfo.email,
                message: this.props.app.contactInfo.message,
                name: this.props.app.contactInfo.name,
            }
        }

        this.handleChangeMail = this.handleChangeMail.bind(this);
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeMessage = this.handleChangeMessage.bind(this);
        this.handleSubmitMail = this.handleSubmitMail.bind(this);
    }
    
    handleChangeName(event) {
        this.setState({ name: event.target.value })
    }

    handleChangeMail(event) {
        this.setState({
            email: event.target.value
        })
    }

    handleChangeMessage(event) {
        this.setState({
            message: event.target.value
        })
    }

    handleSubmitMail(event) {
        event.preventDefault();
        var pwd = this
        var form = new FormData();
        form.append("subject", "contactus");
        form.append("name", this.state.name);
        form.append("email", this.state.email);
        form.append("message", this.state.message);
        API.sendMail(this.props.app.token, form).then((res) => {
            // TODO : We should do something here, redirect or display an info message !
        });
    }

    render() {
        const { t } = this.props
        return (
            <div>
                <Grid stackable id="contact">
                    <Grid.Row id="headerSection">
                        <Grid.Column width={6}>
                            <Segment basic>
                                <Item.Image size='mini' src={ContactNews} id="imageSection" />
                                <Item.Content verticalAlign='middle'>
                                    <Item.Header as='h3' id="titleSection">{t("Item1_title")}</Item.Header>
                                </Item.Content>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row verticalAlign='center'>
                        <Grid.Column>
                          <Form id="contactForm" onSubmit={this.handleSubmitMail}>
                            <input onChange={this.handleChangeName} type='text' fluid placeholder={t("placeholder1")} value = {this.state.name} />
                            <input onChange={this.handleChangeMail} type='text' fluid placeholder={t("placeholder2")} value = {this.state.email} />
                            <TextArea onChange={this.handleChangeMessage} autoHeight placeholder={t("placeholder3")} value = {this.state.message} />
                            <p><input type="checkbox" required name="terms" /> {t("terms_agreement")} <Link to='/termsandconditions'>{t("termsandconditions")}</Link>. </p>
                            <Button
                              size='huge'
                              type="submit"
                              fluid
                              id="hugeBtn"
                              style={{fontFamily: 'MavenProBold'}}>
                              {t("Button1_title")}
                            </Button>
                          </Form>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row columns={3} style={sectionStyle} id="contactInfos">

                        <Grid.Column width={2}>
                        </Grid.Column>

                        <Grid.Column width={4}>
                            <Image centered src={Contact1} /><br />
                            <p>{t("text1")} <br />{t("text2")}</p>
                        </Grid.Column>

                        <Grid.Column width={4}>
                            <Image src={Contact2} centered /><br />
                            <p>{t("text3")}</p>
                        </Grid.Column>

                        <Grid.Column  width={4}>
                            <Image centered src={Contact3} /><br />
                            <p>{t("text5")} <br />{t("text4")}</p>
                        </Grid.Column>

                        <Grid.Column width={2}>
                        </Grid.Column>

                    </Grid.Row>

                </Grid>
            </div>
        );
    }
}
const ContactUsComponent = connect(mapStateToProps)(ConnectedContactUsComponent)
export default translate("ContactUsComponent")(ContactUsComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/Contact/ContactUsComponent.js